/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  FinancialAndTaxDetailsViewModel,
  NotFoundErrorResult,
  ResultOfFinancialAndTaxDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    FinancialAndTaxDetailsViewModelFromJSON,
    FinancialAndTaxDetailsViewModelToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfFinancialAndTaxDetailsViewModelFromJSON,
    ResultOfFinancialAndTaxDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface FinancialAndTaxGetRequest {
    proposalId: number;
}

export interface FinancialAndTaxPostRequest {
    proposalId: number;
    financialAndTaxDetailsViewModel: FinancialAndTaxDetailsViewModel;
}

/**
 * 
 */
export class FinancialAndTaxApi extends runtime.BaseAPI {

    /**
     * Gets the financial and tax details for a party.
     */
    async financialAndTaxGetRaw(requestParameters: FinancialAndTaxGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfFinancialAndTaxDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling financialAndTaxGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/financial-and-tax/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfFinancialAndTaxDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the financial and tax details for a party.
     */
    async financialAndTaxGet(requestParameters: FinancialAndTaxGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfFinancialAndTaxDetailsViewModel> {
        const response = await this.financialAndTaxGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the specified financial and tax details view model.
     */
    async financialAndTaxPostRaw(requestParameters: FinancialAndTaxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfFinancialAndTaxDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling financialAndTaxPost.');
        }

        if (requestParameters.financialAndTaxDetailsViewModel === null || requestParameters.financialAndTaxDetailsViewModel === undefined) {
            throw new runtime.RequiredError('financialAndTaxDetailsViewModel','Required parameter requestParameters.financialAndTaxDetailsViewModel was null or undefined when calling financialAndTaxPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/financial-and-tax/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinancialAndTaxDetailsViewModelToJSON(requestParameters.financialAndTaxDetailsViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfFinancialAndTaxDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Posts the specified financial and tax details view model.
     */
    async financialAndTaxPost(requestParameters: FinancialAndTaxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfFinancialAndTaxDetailsViewModel> {
        const response = await this.financialAndTaxPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
